









































import {Component, Vue} from 'vue-property-decorator';
import {passwordRules} from '@/helpers/rules-validator';
import {resetPassword} from '@/helpers/auth';

@Component({})
export default class ResetPassword extends Vue {

  form = {
    valid: false,
    password: '',
    confirm: '',
    loading: false,
  };

  get token(): string {
    return String(this.$route.query.token || '');
  }

  get passwordRules(): any[] {
    return passwordRules(this.$t('rules.password.empty').toString(), this.$t('rules.password.length').toString());
  }

  get confirmRules(): ((v: string) => true | string)[] {
    return [(v: string) => v === this.form.password || this.$t('reset.mismatch').toString()];
  }

  mounted(): void {
    if (!this.token) {
      this.$router.replace('/login');
    }
  }

  doReset(): void {
    if ((this.$refs.form as HTMLFormElement).validate()) {
      this.form.loading = true;

      resetPassword(this.token, this.form.password).then(() => {
        this.form.loading = false;
        this.$dialog.confirm({actions: [this.$t('close').toString()], text: this.$t('reset.success').toString(), title: this.$t('reset.successTitle').toString()})
          .then(() => this.$router.replace('/login'));
      }).catch((err) => {
        this.form.loading = false;
        const text = err?.status === 400 ? this.$t('reset.invalidToken').toString() : this.$t('errors.unknown').toString();
        this.$dialog.error({text, title: this.$t('errors.error').toString()});
      });
    }
  }
}
